export default "__VITE_ASSET__CmCTN5Er__"